import { SignOutAnswers, SignOutQuestionItem, SignOutQuestionKey, SignOutQuestionsRecord } from '../types/SignOutQuestions';

// Display order, matching the order staff set the questions up in.
const QUESTION_KEYS: { key: SignOutQuestionKey; type: SignOutQuestionItem['type']; }[] = [
    { key: 'question1', type: 'text' },
    { key: 'question2', type: 'text' },
    { key: 'question3', type: 'text' },
    { key: 'yesNoQuestion1', type: 'yesNo' },
    { key: 'yesNoQuestion2', type: 'yesNo' },
];

// The questions a resident has to answer before signing out, in display order. The record is fetched
// with `enabledOnly`, so the backend has already dropped the disabled ones: whatever is present is asked.
const getEnabledSignOutQuestions = (record: SignOutQuestionsRecord | null | undefined): SignOutQuestionItem[] => {
    if (!record) return [];
    return QUESTION_KEYS.flatMap(({ key, type }) => {
        const text = record[key]?.questionText;
        return text !== undefined ? [{ key, text, type }] : [];
    });
};

// Every question needs a non-blank answer, as when the room device keeps asking until it gets one.
const areAllQuestionsAnswered = (items: SignOutQuestionItem[], answers: SignOutAnswers): boolean =>
    items.every(({ key }) => !!answers[key]?.trim());

export { getEnabledSignOutQuestions, areAllQuestionsAnswered };
